
	import { Component, Vue } from 'vue-property-decorator'
	import BaseVue from '@/components/BaseVue'
	import appBar from '@/components/AppBar.vue'
	import { Authority } from '../models/Authority'
	import { EditCondition } from '../models/EmpEditCondition'
	import { Pulldown } from '../models/Pulldown'
	import MoneyTextField from '@/components/MoneyTextField.vue';
    import { Const } from '../scripts/Const'

@Component({
    components: { appBar, MoneyTextField }
})
export default class EmoloyeeMasterEditView extends BaseVue {
	//#region 変数
    private authority: Authority = new Authority()

	private editCondition: EditCondition = new EditCondition()
	private renewDate = ''
	private eventNm = ''
	private dailyWages = 0

	//#region プルダウン型定義
	private divRefereceList: Pulldown[] = []
	private empRefereceList: Pulldown[] = []
	private divList: Pulldown[] = []
	private empTypeList: Pulldown[] = []
    private payTypeList: Pulldown[] = []
	private roleList: Pulldown[] = []
	private empList: Pulldown[] = []

	private weekdaySelected: string[] = []
	private roleSelected: string[] = []
	private empSelected: string[] = []
	private divSelected: string[] = []
	//#endregion

	//#region 活性・非活性制御
	private disableEmpCd = false
	private afterDelete = false
	private disableUseEndDate = false
	//#endregion

	//#region ダイアログ
	private dialog = false
	private title = ''
	private dialogMsg = ''
	//#endregion

	//#region メッセージ
	private showMessage = false
	private messageType = 'info'
	private message = ''
	//#endregion

	//#region カレンダー
	private menu = false
	private menu2 = false
	private date = new Date().toISOString().substr(0, 10)
	//#endregion

	//#region シフト表示制御(v-show)
	private shift2 = false
	private shift3 = false
	private shift2Addbtn = true
	private shift3Addbtn = false
	private shift3Deletebtn = false
	//#endregion
    //#region 給与形態表示制御(v-show)
    private showPayrollInfo = false
	//#endregion


	//#region 参照範囲
	private selectDiv: string
	private selectEmp: string
	//#endregion

	//#region 曜日リスト
	private weekList = [
		{ nm: '日曜日', cd: 'SundayFlg' },
		{ nm: '月曜日', cd: 'MondayFlg' },
		{ nm: '火曜日', cd: 'TuesdayFlg' },
		{ nm: '水曜日', cd: 'WednesdayFlg' },
		{ nm: '木曜日', cd: 'ThursdayFlg' },
		{ nm: '金曜日', cd: 'FridayFlg' },
		{ nm: '土曜日', cd: 'SaturdayFlg' }
	]
	//#endregion
	//#endregion

	//#region 初期表示イベント
	private async created() {
		//マスタ画面からの場合
		if (this.$route.params.empcd != null) {
			this.editCondition.empCd = this.$route.params.empcd
			this.getEmp()
		} else {
			//初期値設定
			//出勤日
			this.weekdaySelected.push('MondayFlg', 'TuesdayFlg', 'WednesdayFlg', 'ThursdayFlg', 'FridayFlg')
			//ソート番号
			this.editCondition.sortPaymentCheck = '999'
			//雇用形態
			this.editCondition.empTypeCd = '10'	//正社員
            //給与形態
            this.editCondition.payTypeCd = '00'	//未定(設定は勤怠時間管理権限(総務)のみで、業務管理権限の場合は非表示のため)
			//定時時間
			this.editCondition.workTimeScheduleBase = '7.5'
			this.editCondition.expectedOvertime = '0'
			//使用開始年月日
			this.editCondition.useStartDate = new Date().toISOString().substr(0, 10)
			//勤務時間
			this.editCondition.shiftTimeStartFirst = '09:00'
			this.editCondition.shiftTimeEndFirst = '17:30'
			this.editCondition.restTimeStart01First = '12:00'
			this.editCondition.restTimeEnd01First = '13:00'
            this.editCondition.restTimeStart02First = '21:30'
            this.editCondition.restTimeEnd02First = '22:00'
            this.editCondition.restTimeStart03First = '01:00'
            this.editCondition.restTimeEnd03First = '01:30'
            this.editCondition.restTimeStart04First = '04:30'
            this.editCondition.restTimeEnd04First = '05:00'
            this.editCondition.restTimeStart05First = '08:00'
            this.editCondition.restTimeEnd05First = '09:00'
			this.editCondition.morningOffTimeStartFirst = '09:00'
			this.editCondition.morningOffTimeEndFirst = '12:00'
			this.editCondition.afternoonOffTimeStartFirst = '13:00'
			this.editCondition.afternoonOffTimeEndFirst = '17:30'

			//日当金額
			this.editCondition.dailyAllowanceAmount = '0'

			//表示制御
			//第2・第3シフト
			this.shift2 = false
			this.shift3 = false
			this.shift2Addbtn = true
			this.shift3Addbtn = false

			//チェックボックス
			this.editCondition.useableFlg = true
			this.editCondition.overtimeCalcFlg = true
		}

		//プルダウン
		this.createpull()

		//画面上部へスクロール
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
	//#endregion

	//#region 保存ボタン押下
	private async save() {
		//メッセージクリア
		this.messageClear()

		this.flgSet()
        console.log(this.editCondition)
		const data = {
			EditCondition: this.editCondition,
			DivRefRangeList: this.divSelected,
			EmpRefRangeList: this.empSelected
		}

		console.log(data)

		try {
			const response = await this.$axios.post('api/EmployeeMasterEdit/Edit', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					this.getEmp()
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 削除ボタン押下
	private clickDelete() {
		//確認ダイアログ
		this.eventNm = 'delete'
		this.openDialog('確認', '削除をします。\r\nよろしいですか。')
	}
	//#endregion

	//#region 削除ボタン押下
	private async deleteData() {
		//メッセージクリア
		this.messageClear()

		const data = {
			EditCondition: this.editCondition,
			DivRefRangeList: this.divSelected,
			EmpRefRangeList: this.empSelected
		}

		try {
			const response = await this.$axios.post('api/EmployeeMasterEdit/Delete', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					//削除完了後は閉じるボタン以外操作させない
					this.afterDelete = true
					this.disableUseEndDate = true
					this.disableEmpCd = true
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region シフト追加ボタン押下
	//#region シフト2表示
	private shift2Add() {
		this.shift2 = true
		this.shift2Addbtn = false
		this.shift3Addbtn = true

		if (this.editCondition.shiftTimeStartSecond == '') {
			//シフト2が初期値の場合のみ、シフト1の内容で上書きする
			this.editCondition.shiftTimeStartSecond = this.editCondition.shiftTimeStartFirst
			this.editCondition.shiftTimeEndSecond = this.editCondition.shiftTimeEndFirst
			this.editCondition.restTimeStart01Second = this.editCondition.restTimeStart01First
			this.editCondition.restTimeEnd01Second = this.editCondition.restTimeEnd01First
			this.editCondition.restTimeStart02Second = this.editCondition.restTimeStart02First
			this.editCondition.restTimeEnd02Second = this.editCondition.restTimeEnd02First
			this.editCondition.restTimeStart03Second = this.editCondition.restTimeStart03First
			this.editCondition.restTimeEnd03Second = this.editCondition.restTimeEnd03First
			this.editCondition.restTimeStart04Second = this.editCondition.restTimeStart04First
			this.editCondition.restTimeEnd04Second = this.editCondition.restTimeEnd04First
			this.editCondition.restTimeStart05Second = this.editCondition.restTimeStart05First
			this.editCondition.restTimeEnd05Second = this.editCondition.restTimeEnd05First
			this.editCondition.restTimeStart06Second = this.editCondition.restTimeStart06First
			this.editCondition.restTimeEnd06Second = this.editCondition.restTimeEnd06First
			this.editCondition.restTimeStart07Second = this.editCondition.restTimeStart07First
			this.editCondition.restTimeEnd07Second = this.editCondition.restTimeEnd07First
			this.editCondition.restTimeStart08Second = this.editCondition.restTimeStart08First
			this.editCondition.restTimeEnd08Second = this.editCondition.restTimeEnd08First
			this.editCondition.restTimeStart09Second = this.editCondition.restTimeStart09First
			this.editCondition.restTimeEnd09Second = this.editCondition.restTimeEnd09First
			this.editCondition.restTimeStart10Second = this.editCondition.restTimeStart10First
			this.editCondition.restTimeEnd10Second = this.editCondition.restTimeEnd10First
			this.editCondition.morningOffTimeStartSecond = this.editCondition.morningOffTimeStartFirst
			this.editCondition.morningOffTimeEndSecond = this.editCondition.morningOffTimeEndFirst
			this.editCondition.afternoonOffTimeStartSecond = this.editCondition.afternoonOffTimeStartFirst
			this.editCondition.afternoonOffTimeEndSecond = this.editCondition.afternoonOffTimeEndFirst
        }

	}
	//#endregion

	//#region シフト3表示
	private shift3Add() {
		this.shift3 = true
		this.shift3Addbtn = false

		if (this.editCondition.shiftTimeStartThird == '') {
			//シフト3が初期値の場合のみ、シフト1の内容で上書きする
			this.editCondition.shiftTimeStartThird = this.editCondition.shiftTimeStartFirst
			this.editCondition.shiftTimeEndThird = this.editCondition.shiftTimeEndFirst
			this.editCondition.restTimeStart01Third = this.editCondition.restTimeStart01First
			this.editCondition.restTimeEnd01Third = this.editCondition.restTimeEnd01First
			this.editCondition.restTimeStart02Third = this.editCondition.restTimeStart02First
			this.editCondition.restTimeEnd02Third = this.editCondition.restTimeEnd02First
			this.editCondition.restTimeStart03Third = this.editCondition.restTimeStart03First
			this.editCondition.restTimeEnd03Third = this.editCondition.restTimeEnd03First
			this.editCondition.restTimeStart04Third = this.editCondition.restTimeStart04First
			this.editCondition.restTimeEnd04Third = this.editCondition.restTimeEnd04First
			this.editCondition.restTimeStart05Third = this.editCondition.restTimeStart05First
			this.editCondition.restTimeEnd05Third = this.editCondition.restTimeEnd05First
			this.editCondition.restTimeStart06Third = this.editCondition.restTimeStart06First
			this.editCondition.restTimeEnd06Third = this.editCondition.restTimeEnd06First
			this.editCondition.restTimeStart07Third = this.editCondition.restTimeStart07First
			this.editCondition.restTimeEnd07Third = this.editCondition.restTimeEnd07First
			this.editCondition.restTimeStart08Third = this.editCondition.restTimeStart08First
			this.editCondition.restTimeEnd08Third = this.editCondition.restTimeEnd08First
			this.editCondition.restTimeStart09Third = this.editCondition.restTimeStart09First
			this.editCondition.restTimeEnd09Third = this.editCondition.restTimeEnd09First
			this.editCondition.restTimeStart10Third = this.editCondition.restTimeStart10First
			this.editCondition.restTimeEnd10Third = this.editCondition.restTimeEnd10First
			this.editCondition.morningOffTimeStartThird = this.editCondition.morningOffTimeStartFirst
			this.editCondition.morningOffTimeEndThird = this.editCondition.morningOffTimeEndFirst
			this.editCondition.afternoonOffTimeStartThird = this.editCondition.afternoonOffTimeStartFirst
			this.editCondition.afternoonOffTimeEndThird = this.editCondition.afternoonOffTimeEndFirst
		}
	}
	//#endregion
	//#endregion

	//#region シフト削除ボタン押下
	//#region シフト2非表示
	private shift2Delete() {
		this.shift2 = false
		this.shift2Addbtn = true
		this.shift3Addbtn = false
		this.shift2init()
	}
	//#endregion

	//#region シフト3非表示
	private shift3Delete() {
		this.shift3 = false
		this.shift3Addbtn = true
		this.shift3Deletebtn = false
		this.shift3init()
	}
	//#endregion

	//#endregion

	//#region 閉じるボタン押下
	private close() {
		this.$router.push({ name: 'EmployeeMaster' })
	}
	//#endregion

	//#region プライベート

	//#region プルダウンの作成
	private async createpull() {
		try {
			const response = await this.$axios.get('api/EmployeeMasterEdit/Index')

			if (response.data.messageData.messageList.length > 0) {
				console.log(response.data.messageData)
			}

			this.divList = response.data.divisionList
			this.empTypeList = response.data.empTypeList
            this.payTypeList = response.data.payTypeList
			this.roleList = response.data.roleList
			this.empList = response.data.empList

            //給与形態表示制御
            this.authority = response.data.authority
            if (this.authority.roleWorkingHoursAdmin) {
                this.showPayrollInfo = true
            }

		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 従業員情報取得
	private async getEmp() {
		try {
			const data = { EditCondition: this.editCondition }

			const response = await this.$axios.post('api/EmployeeMasterEdit/Get', data)

			this.editCondition = response.data.editCondition
			this.divSelected = Object.values(response.data.divRefRangeList)
			this.empSelected = Object.values(response.data.empRefRangeList)

			//取得結果を表示に反映
			this.flgChange(response.data.editCondition)
			this.displayContorol()

			//更新日時
			this.renewDate = response.data.editCondition.renewDate.substr(0, 19)
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 表示制御
	private displayContorol() {
		if (this.editCondition.empCd) {
			this.disableEmpCd = true
		} else {
			this.disableEmpCd = false
		}
		if (this.editCondition.useEndDate) {
			this.disableUseEndDate = true
		} else {
			this.disableUseEndDate = false
		}

		if (this.editCondition.shiftTimeStartSecond) {
			this.shift2Add()
		}
		if (this.editCondition.shiftTimeStartThird) {
			this.shift3Add()
		}
	}
	//#endregion

	//#region 表示用⇒フラグ設定
	private flgSet() {
		//勤務曜日フラグ
		this.editCondition.sundayFlg = this.weekdaySelected.some((dayflg) => dayflg === 'SundayFlg')
		this.editCondition.mondayFlg = this.weekdaySelected.some((dayflg) => dayflg === 'MondayFlg')
		this.editCondition.tuesdayFlg = this.weekdaySelected.some((dayflg) => dayflg === 'TuesdayFlg')
		this.editCondition.wednesdayFlg = this.weekdaySelected.some((dayflg) => dayflg === 'WednesdayFlg')
		this.editCondition.thursdayFlg = this.weekdaySelected.some((dayflg) => dayflg === 'ThursdayFlg')
		this.editCondition.fridayFlg = this.weekdaySelected.some((dayflg) => dayflg === 'FridayFlg')
		this.editCondition.saturdayFlg = this.weekdaySelected.some((dayflg) => dayflg === 'SaturdayFlg')
		//権限フラグ
		this.editCondition.roleSales = this.roleSelected.some((flg) => flg === Const.Authority.SALES)
		this.editCondition.roleLeader = this.roleSelected.some((flg) => flg === Const.Authority.LEADER)
		this.editCondition.roleManager = this.roleSelected.some((flg) => flg === Const.Authority.MANAGER)
		this.editCondition.roleBusinessAdmin = this.roleSelected.some((flg) => flg === Const.Authority.BUSINESS_ADMIN)
		this.editCondition.roleWorkingHoursAdmin = this.roleSelected.some((flg) => flg === Const.Authority.WORKING_HOURS_ADMIN)
	}
	//#endregion

	//#region フラグ⇒表示用に変換
	private flgChange(editcondition: EditCondition) {
		//勤務曜日
		this.weekdaySelected = []
		if (editcondition.sundayFlg) {
			this.weekdaySelected.push('SundayFlg')
		}
		if (editcondition.mondayFlg) {
			this.weekdaySelected.push('MondayFlg')
		}
		if (editcondition.tuesdayFlg) {
			this.weekdaySelected.push('TuesdayFlg')
		}
		if (editcondition.wednesdayFlg) {
			this.weekdaySelected.push('WednesdayFlg')
		}
		if (editcondition.thursdayFlg) {
			this.weekdaySelected.push('ThursdayFlg')
		}
		if (editcondition.fridayFlg) {
			this.weekdaySelected.push('FridayFlg')
		}
		if (editcondition.saturdayFlg) {
			this.weekdaySelected.push('SaturdayFlg')
		}
		//権限
		this.roleSelected = []
		if (this.editCondition.roleSales) {
			this.roleSelected.push(Const.Authority.SALES)
		}
		if (this.editCondition.roleLeader) {
			this.roleSelected.push(Const.Authority.LEADER)
		}
		if (this.editCondition.roleManager) {
			this.roleSelected.push(Const.Authority.MANAGER)
		}
		if (this.editCondition.roleBusinessAdmin) {
			this.roleSelected.push(Const.Authority.BUSINESS_ADMIN)
		}
		if (this.editCondition.roleWorkingHoursAdmin) {
			this.roleSelected.push(Const.Authority.WORKING_HOURS_ADMIN)
		}
	}
	//#endregion

	//#region シフト2初期化
	private shift2init() {
		this.editCondition.shiftTimeStartSecond = ''
		this.editCondition.shiftTimeEndSecond = ''
		this.editCondition.restTimeStart01Second = ''
		this.editCondition.restTimeEnd01Second = ''
		this.editCondition.restTimeStart02Second = ''
		this.editCondition.restTimeEnd02Second = ''
		this.editCondition.restTimeStart03Second = ''
		this.editCondition.restTimeEnd03Second = ''
		this.editCondition.restTimeStart04Second = ''
		this.editCondition.restTimeEnd04Second = ''
		this.editCondition.restTimeStart05Second = ''
		this.editCondition.restTimeEnd05Second = ''
		this.editCondition.restTimeStart06Second = ''
		this.editCondition.restTimeEnd06Second = ''
		this.editCondition.restTimeStart07Second = ''
		this.editCondition.restTimeEnd07Second = ''
		this.editCondition.restTimeStart08Second = ''
		this.editCondition.restTimeEnd08Second = ''
		this.editCondition.restTimeStart09Second = ''
		this.editCondition.restTimeEnd09Second = ''
		this.editCondition.restTimeStart10Second = ''
		this.editCondition.restTimeEnd10Second = ''
		this.editCondition.morningOffTimeStartSecond = ''
		this.editCondition.morningOffTimeEndSecond = ''
		this.editCondition.afternoonOffTimeStartSecond = ''
		this.editCondition.afternoonOffTimeEndSecond = ''
	}
	//#endregion

	//#region シフト3初期化
	private shift3init() {
		this.editCondition.shiftTimeStartThird = ''
		this.editCondition.shiftTimeEndThird = ''
		this.editCondition.restTimeStart01Third = ''
		this.editCondition.restTimeEnd01Third = ''
		this.editCondition.restTimeStart02Third = ''
		this.editCondition.restTimeEnd02Third = ''
		this.editCondition.restTimeStart03Third = ''
		this.editCondition.restTimeEnd03Third = ''
		this.editCondition.restTimeStart04Third = ''
		this.editCondition.restTimeEnd04Third = ''
		this.editCondition.restTimeStart05Third = ''
		this.editCondition.restTimeEnd05Third = ''
		this.editCondition.restTimeStart06Third = ''
		this.editCondition.restTimeEnd06Third = ''
		this.editCondition.restTimeStart07Third = ''
		this.editCondition.restTimeEnd07Third = ''
		this.editCondition.restTimeStart08Third = ''
		this.editCondition.restTimeEnd08Third = ''
		this.editCondition.restTimeStart09Third = ''
		this.editCondition.restTimeEnd09Third = ''
		this.editCondition.restTimeStart10Third = ''
		this.editCondition.restTimeEnd10Third = ''
		this.editCondition.morningOffTimeStartThird = ''
		this.editCondition.morningOffTimeEndThird = ''
		this.editCondition.afternoonOffTimeStartThird = ''
		this.editCondition.afternoonOffTimeEndThird = ''
	}
	//#endregion

	//#region メッセージクリア
	private messageClear() {
		this.message = ''
		this.showMessage = false
	}
	//#endregion

	//#region ダイアログイベント
	private dialogEvent(reply: string) {
		if (reply == 'yes') {
			//はいが押された場合
			switch (this.eventNm) {
			case 'delete':
				this.deleteData()
				break
			default:
				break
			}
		}
		//ダイアログを閉じる
		this.dialog = false
		this.eventNm = ''
	}
	//#endregion

	//#region dialog
	private openDialog(title: string, msg: string) {
		this.title = title
		this.dialogMsg = msg
		this.dialog = true
	}
	//#endregion

	//#endregion
}
